module.exports = __webpack_public_path__ + "static/media/22ESCWA12.c9afd8f1.jpg";